export const ADD_PRICES = 'ADD_PRICES'
export const UPDATE_PRICE = 'UPDATE_PRICE'
export const DELETE_PRICE_BY_INDEX = 'DELETE_PRICE_BY_INDEX'
export const CLEAR_PRICES = 'CLEAR_PRICES'
export const SET_LAST_UPDATED_INDEX = 'SET_LAST_UPDATED_INDEX'
export const RESET_COUNTER = 'RESET_COUNTER'
export const INC_COUNTER = 'INC_COUNTER'
export const SET_TOTAL = 'SET_TOTAL'
export const RESET_TOTAL = 'RESET_TOTAL'
